import script from "./HeaderSettingPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSettingPopup.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSettingPopup.vue?vue&type=style&index=0&id=5aff1206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aff1206"]])

export default __exports__